import React, { useEffect, useState, useContext } from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import JournalForm from './JournalForm';
import JournalIssues from './JournalIssues';
import { ProductContext } from '../../ProductProvider';
import ListArticles from './ListArticles';

export default function JournalView(props) {
  const { viewOnly, formType, initialTab } = props;
  const [key, setKey] = useState(initialTab || 'Journal');
  const { journalData } = useContext(ProductContext);
  const [tabArticles, setTabArticles] = useState(false);
  const [tabIssues, setTabIssues] = useState(false);

  useEffect(() => {
    if (initialTab) {
      setKey(initialTab);
    }
  }, [initialTab]);

  useEffect(() => {
    if (formType === 'New') {
      setTabIssues(true);
      setTabArticles(true);
      setKey('Journal');
    } else {
      setTabIssues(false);
      setTabArticles(false);
    }
  }, [formType]);

  const handleTabSelect = (k) => {
    setKey(k);
    if (k === 'Journal') {
      document.title = "Journal Details - Vidyajyoti College of Theology";
    } else if (k === 'Issues') {
      document.title = "Journal Issues - Vidyajyoti College of Theology";
    } else if (k === 'Articles') {
      document.title = "Journal Articles - Vidyajyoti College of Theology";
    }
  };

  return (
    <div className="journal-view-wrapper">
      <Tabs
        activeKey={key}
        id="journal-view-tabs"
        onSelect={(k) => handleTabSelect(k)}
        mountOnEnter
        unmountOnExit
        className="mb-3 journal-nav-tabs"
      >
        <Tab
          eventKey="Journal"
          title={
            <span>
              <i className="bi bi-journal-text me-1"></i> Journal Details
            </span>
          }
        >
          <JournalForm
            viewOnly={viewOnly}
            formType={formType}
            setTabIssues={setTabIssues}
          />
        </Tab>
        <Tab
          eventKey="Issues"
          title={
            <span>
              <i className="bi bi-calendar-check me-1"></i> Issues Tracking
            </span>
          }
          disabled={tabIssues}
        >
          <JournalIssues
            viewOnly={viewOnly}
            formType={formType}
            handleTabSelect={handleTabSelect}
            setTabArticles={setTabArticles}
          />
        </Tab>
        <Tab
          eventKey="Articles"
          title={
            <span>
              <i className="bi bi-file-earmark-text me-1"></i> Articles Index
            </span>
          }
          disabled={tabArticles}
        >
          <ListArticles viewOnly={viewOnly} formType={formType} handleTabSelect={handleTabSelect} />
        </Tab>
      </Tabs>
    </div>
  );
}
